import LABEL from '../../../business-const/Label/Label'

import {
    gerarArray,
} from '../../../business-components/Array/Array'



export const serieVazia = (series, estudo) => {

    if (series.length === 1) {

        series.push(
            {
                name: LABEL.seriesAreaBar,
                type: 'bar',
                data: gerarArray(null, estudo.current.graficoIdades.length),
            }
        )
    }
}